// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + ({"7337":"ad2866b8","8445":"bc98253f"}[chunkId] || chunkId) + "." + {"4965":"33fafcab1c4a29c6","7337":"f1ede546df3bd613","8445":"2e9fba80bc39a9a4","8848":"bec37cdf36b41400"}[chunkId] + ".js";
};